export const ROOT_FAVOURITES_STATE = 'favourites';

export const INITIAL_STATE = {
  list: [],
  removedList: [],
  error: undefined
};
